import { render } from "./AdminGroupsView.vue?vue&type=template&id=8565abc8&scoped=true"
import script from "./AdminGroupsView.vue?vue&type=script&lang=js"
export * from "./AdminGroupsView.vue?vue&type=script&lang=js"

import "./AdminGroupsView.vue?vue&type=style&index=0&id=8565abc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8565abc8"]])

export default __exports__